<div *ngIf="havePermission">
  <app-audit-filter (search)="handleSearch()"></app-audit-filter>
  <app-audit-results *ngIf="showResults"></app-audit-results>
</div>
